import { Controller } from "stimulus"

// "Today" is the visitor's calendar day, not the server's timezone.
export default class extends Controller {
  static values = { at: String }

  connect() {
    const kickoff = new Date(this.atValue)
    if (Number.isNaN(kickoff.getTime())) return

    const now = new Date()
    const sameDay = kickoff.getFullYear() === now.getFullYear() &&
      kickoff.getMonth() === now.getMonth() &&
      kickoff.getDate() === now.getDate()

    this.element.classList.toggle("d-none", !sameDay)
  }
}
